import * as angular from "angular";
import {IQService} from "angular";
import {ExpensesAlerts} from "./expenses-alerts.service";
import {ExpensesCategoriesRequests} from "./expenses-categories-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class ExpensesCategoriesService {

  constructor(private $q: IQService, private expensesCategoriesRequests: ExpensesCategoriesRequests, private bringozLoaderService: BringozLoaderService,
              private expensesAlerts: ExpensesAlerts) {
  }

  createCategory(category) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesCategoriesRequests.createCategory(category)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.expensesCategoryCreateSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.expensesCategoryCreateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  updateCategory(category) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesCategoriesRequests.updateCategory(category)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.expensesCategoryEditSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.expensesCategoryEditError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  archiveCategory(categoryId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.expensesCategoriesRequests.archiveCategory(categoryId)
      .then((res) => {
        deferred.resolve(res)
        this.expensesAlerts.expensesCategoryArchiveSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.expensesAlerts.expensesCategoryArchiveError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

}

angular
  .module('bringoz.admin.expenses')
  .service('expensesCategoriesService', ExpensesCategoriesService);
